<template>
  <div id="faqPart" class="align">
    <div class="faqPartTitle" v-on:click="closed = !closed">
      <p>{{question}}</p>
      <opener-icon v-if="closed"/>
      <cross2-icon v-else/>
    </div>

    <div class="faqPartContent" v-if="!closed">

      <div v-if="faqVar === 1">

        <div class="subBlock">
          <p style="font-weight: 700">Требования к покупателю</p>
          <p>Для оформления вам понадобится дебетовая или кредитная карта любого банка. Сервис доступен лицам от 18 лет</p>
        </div>

        <div class="subBlock">
          <p style="font-weight: 700">Личный кабинет</p>
          <p>Дату списания платежей можно будет посмотреть в своём личном кабинете.</p>
        </div>

        <div class="subBlock">
          <p style="font-weight: 700">Как можно использовать сервис «kari частями»</p>
          <ul>
            <li>Для онлайн-покупки выберите товары в приложении kari, добавьте их в корзину и перейдите к оплате. На странице оплаты выберите «kari частями», а затем заполните реквизиты карты, с которой спишется первая часть оплаты.</li>
            <li>Для офлайн-покупок в магазинах kari продавец вам предоставит ссылку для регистрации в сервисе. Вам необходимо будет авторизоваться в нем и оплатить первую часть покупки.</li>
          </ul>
        </div>

      </div>

      <div class="partsPayment" v-else-if="faqVar === 3">
        <p>{{answer}}</p>
        <ul>
          <li>- делим оплату на четыре части: первая спишется сразу, следующие три — через каждые две недели</li>
          <li>- делим оплату на четыре части: первая спишется сразу, следующие три — раз в месяц</li>
          <li>- разделим оплату на шесть частей: первая спишется сразу, следующие пять — раз в месяц</li>
        </ul>
      </div>

      <div class="answer" v-else>
        {{answer}}
      </div>

    </div>

  </div>
</template>

<script>
import OpenerIcon from '@/assets/svg/opener-icon';
import Cross2Icon from '@/assets/svg/cross2Icon';
export default {
  name: 'faqPart',
  components: { Cross2Icon, OpenerIcon },
  props: {
    question: {
      type: String,
      default: ''
    },
    faqVar: {
      type: Number,
      default: 0
    },
    answer: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      closed: true
    };
  }
};
</script>

<style scoped>

#faqPart {  margin-bottom: 3.20vw }
#faqPart>.faqPartTitle { background-color: rgba(247, 247, 249, 1); border-radius: 12px; padding: 0 4.27vw; display: flex; justify-content: space-between; align-items: center; width: calc(100% - 8.54vw); height: 18.13vw; cursor: pointer }
#faqPart>.faqPartTitle>svg { width: 7.47vw; height: 7.47vw }
#faqPart>.faqPartTitle>p { font-size: 4.80vw; width: 72.27vw }
#faqPart>.faqPartContent { display: flex; justify-content: space-between; background-color: rgba(247, 247, 249, 1); border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; padding: 5.33vw 4.27vw; position: relative; top: -1.5vw }
#faqPart>.faqPartContent .subBlock { margin-bottom: 4vw }
#faqPart>.faqPartContent .subBlock>ul { padding-inline-start: 6.33vw }
#faqPart>.faqPartContent>.answer { font-size: 4vw }
#faqPart>.faqPartContent>.partsPayment>ul { margin: 0; padding-inline-start: 0; list-style-type: none }
#faqPart>.faqPartContent>.partsPayment>ul>li { font-size: 4vw }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {

  #faqPart { margin-bottom: 20px }
  #faqPart>.faqPartTitle { padding: 0 40px; width: calc(100% - 40px); height: 122px }
  #faqPart>.faqPartTitle>p { font-size: 24px; width: 747px }
  #faqPart>.faqPartTitle>svg { width: 42px; height: 42px }
  #faqPart>.faqPartContent { padding: 0 40px 40px 40px; position: relative; top: -5px; width: calc(100% - 40px) }
  #faqPart>.faqPartContent .subBlock { margin-bottom: 35px }
  #faqPart>.faqPartContent .subBlock>ul { padding-inline-start: 20px }
  #faqPart>.faqPartContent>.partsPayment>ul>li { font-size: 18px }
  #faqPart>.faqPartContent>.answer { width: 938px; font-size: 18px }
}
</style>
